import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=055e5d2b&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('055e5d2b')) {
      api.createRecord('055e5d2b', component.options)
    } else {
      api.reload('055e5d2b', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=055e5d2b&", function () {
      api.rerender('055e5d2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2RmR2VfPmcnHT/JS/comp/openstreetmap.vue"
export default component.exports